let base_url = "";
let user_srvc_url = "";
let mul_srvc = "";
let local_srvc = "";
if (process.env.REACT_APP_ENV === "development") {
    user_srvc_url = "https://user-dev.refactor.academy";
    base_url = "https://gateway-dev.refactor.academy";
    mul_srvc = "https://proctorgateway-dev.refactor.academy";
}
else if (process.env.REACT_APP_ENV === "production") {
    base_url = "https://gateway-prod.refactor.academy";
    user_srvc_url = "https://user-prod.refactor.academy";
    mul_srvc = "https://proctorgateway-prod.refactor.academy";
}
else if (process.env.REACT_APP_ENV === "staging") {
    base_url = "https://gateway-staging.refactor.academy";
    local_srvc = "http://localhost:6005";
    user_srvc_url = "https://user-staging.refactor.academy";
    mul_srvc = "https://proctorgateway-staging.refactor.academy";
}
export const MANAGER_ENDPOINTS = {
    GET_MANUAL_TEMPLATE: `${base_url}/hmsrvc/manual-feedback/get-template`,
    GET_HM_FEEDBACK_V2: `/hmsrvc/manual-feedback/v2/getHmFeedback`,
    GET_USER_DETAILS: `/useradmin/group/user-details`,
    GET_PROFILE_PHOTO_URL: `/useradmin/group/profile-photo-url`,
    SUBMIT_HM_FEEDBACK_V2: `/hmsrvc/manual-feedback/v2/submit-hm-feedback`,
    GET_FEEDBACK_TEMPLATE_V2: `/hmsrvc/manual-feedback/v2/get-feedback-template`,
    SUBMIT_ADDITIONAL_HM_FEEDBACK_V2: `/hmsrvc/manual-feedback/v2/submit-additional-hm-feedback`,
    GET_ADDITIONAL_HM_FEEDBACK_V2: `/hmsrvc/manual-feedback/v2/get-additional-hm-feedback`,
    SEARCH_MANAGER_BY_NAME_EMAIL: `/hmsrvc/hiring-manager/search-hm`,
    INVITE_ADDITIONAL_HMS: `/hmsrvc/hiring-manager/invite-additional-hms`,
};
export const INTG_ENDPOINTS = {
    GET_ALL_INTG: `${base_url}/apt-srvc/ms-teams/get-all-intg`,
    GET_TOKEN_BY_CODE: `${base_url}/apt-srvc/ms-teams/ms/get-token-by-code`,
    GET_ALL_CAL: `${base_url}/apt-srvc/ms-teams/ms/get-calenders`,
    SAVE_CALENDAR_ID: `${base_url}/apt-srvc/ms-teams/ms/add-calendar-id`,
    TOGGLE_INTG: `${base_url}/apt-srvc/ms-teams/ms/update-intg`,
    CREATE_EVENT: `${base_url}/apt-srvc/ms-teams/ms/create-event`,
    GET_ACCESS_TOKEN: `${base_url}/apt-srvc/ms-teams/ms/get-token-by-refresh-user-id`,
    GET_EVENTS_MS: `${base_url}/apt-srvc/ms-teams/ms/get-events`,
    UPDATE_EVENT: `${base_url}/apt-srvc/ms-teams/ms/update-event`,
    DELETE_EVENT: `${base_url}/apt-srvc/ms-teams/ms/delete-event`,
    GET_EVENTS_OTHERS: `${base_url}/apt-srvc/ms-teams/ms/get-events-others`,
};
export const MEETING_ENDPOINTS = {
    GET_ACS_TOKEN: `${base_url}/apt-srvc/ms-teams/get-user-acs-token`,
    START_ACS_RECORDING: `${base_url}/apt-srvc/ms-teams/acs-recording/start`,
    STOP_ACS_RECORDING: `${base_url}/apt-srvc/ms-teams/acs-recording/stop`,
    GET_HM_MEETING_LINK: `${base_url}/hmsrvc/hiring-manager/meeting-link`,
    END_HM_ROUND: `${base_url}/int-srvc/interview/end-hm-round`,
    CREATE_MEETING_SUBSCRIPTION: `${base_url}/apt-srvc/meeting-data/create-meeting-subscription`,
};
export const MS_ADAPTER_ENDPOINTS = {
    // GET_LOGIN_URL: `${"http://localhost:6005"}/ms/get-login-url`,
    GET_LOGIN_URL: `${base_url}/ms/get-login-url`,
    EXCHANGE_CODE_AND_ACS_TOKEN: `${base_url}/ms/code-token-exchange`,
    GET_TEAMS_REFRESH_AND_ACS_TOKEN_BY_EMAIL: `${base_url}/apt-srvc/adapter/ms/teams-refresh-token-and-acs-token-by-email`,
    // EXCHANGE_CODE_AND_ACS_TOKEN: `${"http://localhost:6005"}/ms/code-token-exchange`,
};
export const UNILITIES_ENDPOINTS = {
    SIGN_URL: `/utilities/sign-url/sign-url`,
};
